// extracted by mini-css-extract-plugin
export default {"otp":"index_otp__fxXaw","signpreview":"index_signpreview__PyBXk","value_div":"index_value_div__DHjJ7","vl":"index_vl__9dwqL"};